export const DISPLAY_CURRENCIES = ['USD', 'AUD', 'GBP', 'EUR'] as const
export type DisplayCurrency = (typeof DISPLAY_CURRENCIES)[number]

export const CURRENCY_STORAGE_KEY = 'bv_display_currency'
export const CURRENCY_MANUAL_KEY = 'bv_currency_manual'
export const FX_CACHE_KEY = 'bv_fx_rates_v1'

export type FxRates = {
  base: 'USD'
  fetchedAt: string
  rates: Record<Exclude<DisplayCurrency, 'USD'>, number>
}

export type DisplayPriceInfo = {
  usd: number
  display: number
  currency: DisplayCurrency
  formatted: string
  symbol: string
}
